
export const FETCH_INTEGRATOR = "FETCH_INTEGRATOR";
export const FETCH_INTEGRATOR_START = "FETCH_INTEGRATOR_START";
export const FETCH_INTEGRATOR_SUCCESS = "FETCH_INTEGRATOR_SUCCESS";
export const FETCH_INTEGRATOR_ERROR = "FETCH_INTEGRATOR_ERROR";

export const FETCH_PACS = "FETCH_PACS";
export const FETCH_PACS_START = "FETCH_PACS_START";
export const FETCH_PACS_SUCCESS = "FETCH_PACS_SUCCESS";
export const FETCH_PACS_ERROR = "FETCH_PACS_ERROR";

export const SET_MIPS_PACS = "SET_MIPS_PACS";

export const GENERATE_SESSIONID = "GENERATE_SESSIONID";
export const GENERATE_SESSIONID_START = "GENERATE_SESSIONID_START";
export const GENERATE_SESSIONID_SUCCESS = "GENERATE_SESSIONID_SUCCESS";
export const GENERATE_SESSIONID_ERROR = "GENERATE_SESSIONID_ERROR";

export const CLOSE_SESSION = "CLOSE_SESSION";
export const CLOSE_SESSION_START = "CLOSE_SESSION_START";
export const CLOSE_SESSION_SUCCESS = "CLOSE_SESSION_SUCCESS";
export const CLOSE_SESSION_ERROR = "CLOSE_SESSION_ERROR";

export const LOAD_ORDER = "LOAD_ORDER";
export const LOAD_ORDER_START = "LOAD_ORDER_START";
export const LOAD_ORDER_SUCCESS = "LOAD_ORDER_SUCCESS";
export const LOAD_ORDER_ERROR = "LOAD_ORDER_ERROR";

export const UNLOAD_ORDER = "UNLOAD_ORDER";
export const UNLOAD_ORDER_START = "UNLOAD_ORDER_START";
export const UNLOAD_ORDER_SUCCESS = "UNLOAD_ORDER_SUCCESS";
export const UNLOAD_ORDER_ERROR = "UNLOAD_ORDER_ERROR";

export const SET_MICROPHONE_DEVICE_ID = "SET_MICROPHONE_DEVICE_ID";
export const SET_PAIRED_DICTATION_DEVICE = "SET_PAIRED_DICTATION_DEVICE";

export const SET_DEADMAN_SWITCH = "SET_DEADMAN_SWITCH";


export const fetchPacs = () => {
    return {
        type: FETCH_PACS,
    };
};

export const fetchIntegrator = () => {
    return {
        type: FETCH_INTEGRATOR,
    };
};

export const generateSessionID = (risUser) => {
    return {
        type: GENERATE_SESSIONID,
        risUser
    };
};

export const loadOrder = (payload) => {
    return {
        type: LOAD_ORDER,
        payload
    };
};

export const unloadOrder = (payload) => {
    return {
        type: UNLOAD_ORDER,
        payload
    };
};

export const setMicrophoneDeviceId = (deviceId) => {
    return {
        type: SET_MICROPHONE_DEVICE_ID,
        deviceId
    };
};

export const setPairedDictationDevice = (device) => {
    return {
        type: SET_PAIRED_DICTATION_DEVICE,
        device
    };
};

export const setDeadmanSwitch = (useDeadmanSwitch) => {
    console.log("setDeadmanSwitch", useDeadmanSwitch);
    return {
        type: SET_DEADMAN_SWITCH,
        useDeadmanSwitch
    };
};